import { ref, watch } from 'vue'

// Pinned projects float to the top of the projects list. Module-scope so the
// pin buttons on cards/tree rows and the ordering in ProjectList share it.
const STORAGE_KEY = 'pinnedProjectIds'

const readStored = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY))
    return Array.isArray(stored) ? stored : []
  } catch (e) {
    return []
  }
}

const pinnedIds = ref(readStored())

watch(pinnedIds, (value) => localStorage.setItem(STORAGE_KEY, JSON.stringify(value)))

const isPinned = (projectId) => pinnedIds.value.includes(projectId)

const togglePin = (projectId) => {
  pinnedIds.value = isPinned(projectId)
    ? pinnedIds.value.filter((id) => id !== projectId)
    : [...pinnedIds.value, projectId]
}

export const useProjectPins = () => ({ pinnedIds, isPinned, togglePin })
